module.exports = new __parcel__URL__("flute_select.05be7810.mp3").toString();